import type { GetMyCampaignStatusesResponse } from "schema/gen/es/chiikipoint/wallet/v2/service_pb";
import type { R8CampaignConfig } from "../../../config";
import type { CurrentTime } from "../../../libs/date";

export type R8CampaignBannerType =
  | "not-applied" // 未応募（応募可能）
  | "applied" // 応募済み
  | "campaign-ended" // キャンペーン終了（上限到達）
  | "received" // 対象外（みやぎ防災ウェルカムポイントのみ）
  | "hidden"; // 非表示

export function getR8CampaignBannerType(
  campaignStatuses: GetMyCampaignStatusesResponse | null,
  currentTime: CurrentTime,
  isTargetResident: boolean,
  config: R8CampaignConfig,
): R8CampaignBannerType {
  if (currentTime.source === "client") {
    return "hidden";
  }

  // キャンペーン開始前は非表示
  if (currentTime.date < config.startDate) {
    return "hidden";
  }

  // 応募期限を過ぎた場合は非表示
  if (currentTime.date > config.endDate) {
    return "hidden";
  }

  // 対象市区町村の住民以外は非表示
  if (!isTargetResident) {
    return "hidden";
  }

  // APIレスポンスがない場合は非表示
  if (!campaignStatuses) {
    return "hidden";
  }

  const { r8AntiInflation } = campaignStatuses;

  // r8AntiInflationに応募済みの場合は応募済みバナー
  if (r8AntiInflation?.isApplied) {
    return "applied";
  }

  // r8AntiInflation.isWinLimitReached の場合はキャンペーン終了バナー表示
  if (r8AntiInflation?.isWinLimitReached) {
    return "campaign-ended";
  }

  // すべての条件を満たす場合は未応募バナー
  return "not-applied";
}
